import React, {useState} from "react";
import {Modal} from 'react-bootstrap';
import './UploadImageModal.css'
import {getResource, uploadFileResource} from "../service/http-service";
import Delete from '../../assets/img/profile-images/delete.png'
import "../user-profile/profile-design/ProfilePersonalInformationSegment.css"


export default function UploadImageModal ({btnText,entity,setEntity,updateEntity,setUpdateEntity, addImageEntity, setAddImageEntity, candidateImageId}) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [backError, setBackError] = useState('')

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
    };

    const handleSubmission = () => {
        let formData = new FormData();
        formData.append("file", selectedFile);

        if(entity.id){
            formData.append("entityId", entity.id);
        }else{
            formData.append("entityId", 0);
        }

        // if(entity.candidate && entity.candidate.id){
        //     formData.append("candidateId", entity.candidate.id);
        // }else{
        //     formData.append("candidateId", entity.id);
        // }


        // for (let key of formData.entries()) {
        //     console.log(key[0] + ', ' + key[1]);
        // }
        uploadFileResource('candidates/add_candidate_image', formData).then((data) => {
            console.log(data.data)
            // setEntity({candidate: entity.candidate})
            setAddImageEntity(!addImageEntity)
            setUpdateEntity(!updateEntity)
            handleClose();
        }).catch((exception) => {
            setBackError("Прикачената слика ја надминува дозволената големина");

        })

    };

    const addImage = () => {
        let fileInput = document.getElementById('fileInput');
        let fileDisplayArea = document.getElementById('fileDisplayArea');


        fileInput.addEventListener('change', function (e) {
            let file = fileInput.files[0];
            let imageType = /image.*/;

            if (file.type.match(imageType)) {
                let reader = new FileReader();
                reader.onload = function (e) {
                    fileDisplayArea.innerHTML = "";
                    let img = new Image();
                    img.src = reader.result;
                    fileDisplayArea.appendChild(img);
                }
                reader.readAsDataURL(file);
            } else {
                fileDisplayArea.innerHTML = "File not supported!"
            }
        });
    }

    const deletePhoto = () => {
        getResource('candidates/delete_photo').then(data => {
            console.log(data.data)
            // setEntity({candidate: entity.candidate})
            setAddImageEntity(!addImageEntity)
            setUpdateEntity(!updateEntity)
            handleClose()
        }) .catch((exception) => {
            console.error(exception);
            console.log(exception.response.data.message)
            throw exception;
        });
    }



    return (
        <>
            <div className="add-profile-image" onClick={handleShow}>
                {btnText}
            </div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Додади слика</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="background-form col-12 p-0">
                        {(entity) && (<>
                            {candidateImageId ? <b className="blue">Промени ја сликата</b> :
                                <b className="blue">Додади слика</b>}
                                <form id="newDocForm" className="col-lg-10 offset-lg-1">
                                    <input id="fileInput"
                                           className="input-form w-100 mt-3"
                                           type="file" name="file"
                                           formtype="multipart/form-data"
                                           onChange={(e) => changeHandler(e)}
                                           onClick={() => addImage()}/>
                                    <div id="fileDisplayArea"></div>
                                </form>
                            </>)}
                    </div>
                    {backError && <b className="blue">{backError}</b>}
                </Modal.Body>
                <Modal.Footer>
                    {candidateImageId &&  <div className='w-100 d-flex justify-content-center align-items-center'>
                        <b className="text-danger">Избриши ја постоечката слика</b>
                        <img className="delete-icon" src={Delete}
                        onClick={() => deletePhoto()}/>
                    </div>}
                     <div className="d-flex justify-content-between w-100">
                        <div
                            className="btn-form"
                            onClick={() => {
                                handleClose()
                                setEntity({candidate: entity.candidate})
                            }}>
                            Затвори
                        </div>
                        <div
                            className="btn-form"
                            onClick={(e) => {
                                handleSubmission();

                            }}
                           >Додади</div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}